import AsigProject from "../../models/asig-project";
import {
  axiosInstance as Repository,
} from "../repository";

const RESOURCE = "/asig-projects";

function getInstance(item) {
  const obj = new AsigProject();
  obj.serviceAccountId = item.organization_id;
  obj.asigProjectId = item.project_id;

  return obj;
}

export default {

  async index(serviceAccountId) {
    const request_params = {
      organization_id: serviceAccountId,
    };
    const response = await Repository.get(`${RESOURCE}`, {
      params: request_params,
    });
    const res = [];
    response.data.items.forEach((item) => {
      res.push(getInstance(item));
    });
    return res;
  },
};
